import "./AdminWorkspaceUsers.css";

import * as m from "../../../../model/model";

import { useAppDispatch, useAppSelector } from "../../../../store";

import Buckets from "../../../common/bucket/Buckets";
import ModalBase from "../../../../modals/ModalBase";
import React from "react";
import { loadUsersThunk } from "../../../../store/slices/adminThunks";
import { useLocale } from "../../../../hooks/useLocale";
import { useModal } from "../../../../context/ModalContext";
import { workspaceActions } from "../../../../store/slices/workspaceSlice";

export default function AdminWorkspaceUsers() {
  const currentWorkspace = useAppSelector(
    (state) => state.workspace.currentWorkspace
  );
  const users = useAppSelector((state) => state.admin.users);
  const [selectedUser, setSelectedUser] =
    React.useState<m.WorkspaceUser | null>(null);

  const { showModal, hideModal } = useModal();
  const dispatch = useAppDispatch();
  const { collator } = useLocale();

  React.useEffect(() => {
    dispatch(loadUsersThunk());
  }, [dispatch]);

  const onAddUsersClick = () => {
    let selectedUser: string;

    const onUserChange = (e: any) => {
      selectedUser = e.target.value;
    };

    const onAdd = () => {
      const usr = users?.find((u) => u.email === selectedUser);
      if (usr) {
        dispatch(workspaceActions.addUser(usr));
      }
    };

    const options = users
      ?.filter(
        (u) => !currentWorkspace?.users?.find((cu) => cu.email === u.email)
      )
      .map((u) => (
        <option key={u.email} value={u.email}>
          {u.name}
        </option>
      ));

    showModal(
      <ModalBase
        header="Add User"
        body={
          <>
            <select onChange={onUserChange}>
              <>
                {<option value="">Select User</option>}
                {options}
              </>
            </select>
            <input type="checkbox" title="Send invitation" checked={true} />
          </>
        }
        footer={
          <>
            <button onClick={hideModal}>Done</button>
            <button onClick={onAdd}>Add</button>
          </>
        }
      />
    );
  };

  if (!currentWorkspace?.users) return null;
  if (!users) return null;

  return (
    <div className="panel-users">
      <div className="panel-users-header">
        <div className="panel-users-title">Users</div>
        <button className="loa-button" onClick={onAddUsersClick}>
          Add Users
        </button>
      </div>
      <div className="panel-users-container">
        <div className="panel-users-list">
          {[...currentWorkspace.users]
            .sort((u1, u2) => collator.compare(u1.name, u2.name))
            .map((u) => (
              <div
                key={u.email}
                className={`panel-user ${
                  selectedUser?.email === u.email ? "selected" : ""
                }`}
                onClick={() => setSelectedUser(u)}
              >
                <div>{u.name} </div>
              </div>
            ))}
        </div>
        <div className="panel-user-details">
          {selectedUser && (
            <>
              <p className="panel-user-name">{selectedUser.name}</p>
              <p className="panel-user-email">{selectedUser.email}</p>
              <Buckets
                root={`loa/dynamic/workspaces/${currentWorkspace.id}/users/${selectedUser.id}`}
                permissions={["admin"]}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
